 <template>
    <el-dialog ref="dialogId" :visible.sync="isShow" custom-class="choose-per-dialog" :width="dialogWidth" title="选择购入设备" append-to-body @closed="beforeCannel" :close-on-click-modal="false">
        <div class="oraWrap bm" v-loading="loading">
            <div class="wrap-left  bm bm-f1" v-loading='loadingState'>
                <div class="search-box bm bm-ver">
                    <el-form>
                        <el-row>
                            <el-col :span="24">
                                <el-input
                                    size="small"
                                    clearable
                                    placeholder="请输入搜索内容"
                                    prefix-icon="el-icon-search"
                                    v-model="formInline.deviceName"
									v-on:input="changeDevice">
                                </el-input>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8" >
                                <el-form-item label-width="0px" >
                                    <el-select style="width:100%"  size="small"
                                                v-model="formInline.assetsKindName"
                                                placeholder="请选择设备大类" clearable
												@change="handleChange">
                                        <el-option v-for="item in assetsKindList"
                                                    :key="item.assetsKindName"
                                                    :label="item.assetsKindName"
                                                    :value="item.assetsKindName">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label-width="10px" >
                                    <el-select style="width:100%"  size="small"
                                                v-model="formInline.assetsTypeName"
                                                placeholder="请选择设备中类" clearable
												@change="handleTypeChange">
                                        <el-option v-for="item in assetsTypeList.assetsTypeList"
                                                    :key="item.name"
                                                    :label="item.name"
                                                    :value="item.name">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
							<el-col :span="8">
                                <el-form-item label-width="10px" >
                                    <el-select style="width:100%"  size="small"
                                                v-model="formInline.assetsSubTypeName"
                                                placeholder="请选择设备小类" clearable
												@change="handleSubTypeChange">
                                        <el-option v-for="item in assetsSubTypeList.assetsSubTypeList"
                                                    :key="item.name"
                                                    :label="item.name"
                                                    :value="item.name">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-checkbox-group v-model="supplierChecked" class="bm bm-f1 " >
                        <div class="search-show-box " :style="{height: leftBoxHeight + 'px',overflow: 'auto'}" v-loadmore="loadMore">
                            <div class="per-box scroll-box bm bm-ac" v-for="(item, index) in listData"  :key="index">
                                <div class="check-box"> 
                                    <el-checkbox  :label="item"  @change="checked=>chooseSupplierChange(checked, item)"  :key="index"></el-checkbox>
                                </div>
                                <div class="bm bm-f1 scroll-box-val">
                                    <!-- <div class="pic-box"><div class="pic">{{item.deviceName | picStr}}</div></div> -->
                                    <div class="bm bm-f1 bm-ver">
                                        <div class="row-one bm ">
                                            <div class="user-name">{{item.deviceModel}}{{item.deviceName}}</div>
                                        </div>
                                        <div class="row-two bm bm-pj">
                                            <div class="bm">
												<div class="department" :title="item.deviceCode">{{item.deviceCode}}</div>
												<div class="on-line"></div>
												<div class="hospital" :title="item.assetsKindName">{{item.assetsKindName}}</div>
												<div class="on-line"></div>
												<div class="hospital" :title="item.assetsTypeName">{{item.assetsTypeName}}</div>
												<div class="on-line"></div>
												<div class="hospital" :title="item.assetsSubTypeName">{{item.assetsSubTypeName}}</div>
											</div>
											<div style="flex:0 0 auto">
												历史参考价：
												<span v-if="item.referencePrice">
													{{money(item.referencePrice)}}元/{{item.baseMeasureUnit}}
												</span>
												<span v-else>无</span>
											</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="load" v-if="loadShow">
                                <div v-if="loadtxt == '暂无数据'" class="bm bm-ver bm-ac">
                                    <div class="not-devices">没有您要查找的设备</div>
                                    <el-button style="width: 100px;" size="mini" @click="openAddDevice"><i class="el-icon-plus"></i> 点此新增</el-button>
                                </div>
                                <div v-else>{{loadtxt}}</div>

                            </div>
                        </div>
                    </el-checkbox-group>
                </div>
            </div>
            <div class="wrap-right bm-f1" v-if="infinite">
                <div class="choosed-box">
                    <div class="choosed-txt">已选：</div>
                    <div class="choosed-show" :style="{height: rightBoxHeight + 'px',overflow: 'auto'}">
                        <div class="cshow-box bm" v-for="(item, index) in showPer" :key="index">
                            <div class="bm bm-f1 bm-ver">
                                <div class="row-one bm ">
                                    <div class="user-name">{{item.deviceModel}}{{item.deviceName}}</div>
                                </div>
                                <div class="row-two bm ">
                                    <div class="department" :title="item.deviceCode">{{item.deviceCode}}</div>
                                    <div class="on-line"></div>
                                    <div class="hospital" :title="item.assetsKindName">{{item.assetsKindName}}</div>
                                    <div class="on-line"></div>
                                    <div class="hospital" :title="item.assetsTypeName">{{item.assetsTypeName}}</div>
									<div class="on-line"></div>
                                    <div class="hospital" :title="item.assetsSubTypeName">{{item.assetsSubTypeName}}</div>
                                </div>
                            </div>
                            <div class="del">
                                <div class="el-icon-close del-btn" @click="del(item)"></div>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <div class="choosed-btn-box">
                        <el-button size="small" @click="cannel">取消</el-button>
                        <el-button size="small" type="danger" @click="callback">下一步<span v-if="showPer.length > 0">({{showPer.length}})</span></el-button>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
// const R = require('ramda')
import  '@/utils/loadMore.js';
import { deviceApi } from "@/services";
import { setTimeout } from 'timers';
import $money from "@/utils/money.js"

export default {
    name: "choose-devices",
    props: {
        //是否展示框
        showDialog: {
            type: Boolean
        },
        //是否记住所选带出
        rememberLastSelect: {
            type: Boolean,
            default:true
        },
        //选择中的设备
        section: {
            type: Array,
            default: () => {
                return [];
            }
        },
        //是否单选 还是多选
        infinite: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            provinceArr: [],//省市县的结果
            //全部登记
            listData:[],//数据列表
            jobLevel:"",
            //机构类型
            orgType:"",
            //省市区
			provinceList: [],
			provinceData: [],
			provinceProps: {
				value: "areaCode",
				label: "areaName",
				children: "list"
			},
            loading: false,
            isShow: this.showDialog,
            isIndeterminate: false,
            supplierChecked: [],
            showPer: [],
            perArr: [],
            leftBoxHeight: 0,
            rightBoxHeight: 0,
            searchBoxHeight: 0,
            leftBoxOverflow: 'auto',
            timeoutId: null,
            page: 1,
            pageTotals: 0,
            loadtxt: '加载中...',
            loadShow: false,
            // 表格
			formInline: {
				deviceName: "",
				assetsKindName: "",
				assetsTypeName: "",
				assetsSubTypeName:"",
				pageNo: 1,
				pageSize: 30,
			},
            init:{},
            loadingState:true,
            assetsKindList:this.$store.state.init.configInfo.deviceKindInfoList,
			assetsTypeList:{
				assetsTypeList:[]
			},
			assetsSubTypeList:{
				assetsSubTypeList:[]
			},
			assetsSubTypeNameList:[],
            deviceNameTemp:""
        };
    },
    mounted () {
        let that = this;
        //设置框的高度
        this.setHeight(); 
        //获取数据列表
		this.getSearch(this.formInline);
    },
    methods: {
		
		money(data){
			return $money(data,2,'')
		},
        //添加新设备
        openAddDevice(){
            this.$emit('openAddDevice', "");
        },
        //医生等级转换
        doctorLevel(val){
            let name = "";
            if(val && this.init && this.init.companyDictionary){
                this.init.companyDictionary.supplierClassifyList.forEach((item)=>{
                    if(val == item.id){
                        name = item.name;
                    }
                });
            }
            return name;
        },
        //获取列表
		getSearch(opt) {
			deviceApi.queryDeviceList(opt).then((res) => {
                let obj =  res.responseData;
                if (this.formInline.pageNo == 1) {
                    this.listData = [];
                    this.formInline.pageNo = 1;
                    this.pageTotals = 0;
				}
                if (obj.totalRecords == 0) {
                    this.loadShow = true;
                    this.loadtxt = '暂无数据';
                } else if (obj.totalPages == 1) {
                    this.loadShow = false;
                } else {
                    this.loadShow = true;
                    this.loadtxt = '加载中...';
                }
                this.pageTotals = obj.totalPages;
                //入参不全着补齐
                this.supplierChecked.forEach((item,index) => {
                    obj.list.forEach((value) => {
                        if(item.deviceCode == value.deviceCode){
                            this.supplierChecked[index] = value;
                        }
                    });
                });
                //重新得到选中数据
                let arr = [];
                this.supplierChecked.forEach(res => {
                    arr.push(res);
                });
                this.showPer = arr;
                this.listData = this.listData.concat(obj.list);
                this.loadSign = true;
                this.formInline.pageNo++;
                this.loadingState = false;
            }).catch(e => {
                this.leftBoxOverflow = 'auto';
            }).finally(() => {
                this.leftBoxOverflow = 'hidden';
            });
        },
        //删除人员
        del (json) {
            let index = R.findIndex(R.propEq('deviceCode', json.deviceCode))(this.supplierChecked);
            if (index != -1) {
                this.supplierChecked.splice(index, 1);
            }
            let checkedCount = this.supplierChecked.length;
            // this.checkAll = checkedCount === this.perArr.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.perArr.length;
        },
        //设置高度
        setHeight () {
            let windowHeight = document.documentElement.clientHeight;
            let dialogHeight = this.$refs.dialogId?this.$refs.dialogId.offsetHeight:0;
            let that = this;
            let wheight1 = windowHeight / 2 -40;//左
            let wheight2 = windowHeight / 2 -20;//右
            let wheight3 = windowHeight / 2 - 30;//查询
            this.leftBoxHeight = wheight1;
            this.rightBoxHeight = wheight2;
            if (this.infinite) {
                this.searchBoxHeight = wheight3;
            } else {
                this.searchBoxHeight = wheight3 - 59;
            }
            window.onresize = () => {
                this.setHeight();
            };
        },
        //选择
		chooseSupplierChange (checked, value) {
			this.supplierChecked =  this.supplierChecked[0] == undefined?[]:this.supplierChecked;
			let index = this.supplierChecked.length == 0 ?-1:R.findIndex(R.propEq('deviceCode', value.deviceCode))(this.supplierChecked);
			if (checked) {
				if (index == -1) {
					this.supplierChecked.push(value);
				}
			} else {
				if (index != -1) {
					this.supplierChecked.splice(index, 1);
				}
			}
			let checkedCount = this.supplierChecked.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.perArr.length;
		},
        //搜索列表
        searchFunc (val) {
            let _this = this;
			clearTimeout(this.timeoutId);
			this.timeoutId = setTimeout(() => {
				_this.formInline.pageNo = 1;
				_this.getSearch(this.formInline);
			}, 1000);
		},
		beforeCannel(){
            if(!this.rememberLastSelect)
                {
                    //V2.0 取消记忆上次所选
                    this.showPer = [];
                    this.supplierChecked=[];
                }
			this.$emit('closeDevices', false);
		},
        //取消选择框
        cannel () {
			// 取消时新增的选择不被考虑
			this.supplierChecked=[];
            this.showPer = [];
            
            this.section.forEach(res => {
				let isOk = false;
				this.showPer.forEach(resp => {
					if(resp.deviceCode == res.deviceCode){
						isOk = true;
					}
				});
				if(!isOk){
					this.supplierChecked.push(res);
				}
            });
            
			
			this.resetData();
			this.$emit('cannel', false);
        },
        //确认回调
        callback () {
            if(this.showPer.length > 0 ){
                //优先用传入的数据
				this.showPer.forEach((item,index) => {
                    let deviceIndex = R.findIndex(R.propEq('deviceCode', item.deviceCode))(this.section);
                    if(deviceIndex != -1){
                        this.showPer[index] = this.section[deviceIndex];
                    }
				});
                console.log(this.showPer,"this.showPer");
                this.$emit('callback', {show: false,res: this.showPer});
                this.resetData();
            }else{
                this.$message.error('请选择设备');
            }
        },
        //重置选择框
        resetData () {
            this.loading = false;
            this.isShow = this.showDialog;
            this.isIndeterminate = false;
            this.listData = [];
            this.leftBoxOverflow = 'auto';
            this.timeoutId = null;
            this.formInline.pageNo = 1;
            this.pageTotals = 0;
            this.loadtxt = '加载中...';
            this.loadShow = false;
			this.formInline.deviceName= "";
			this.formInline.assetsKindName= "";
			this.formInline.assetsTypeName= "";
			this.formInline.assetsSubTypeName= "";
            this.provinceArr =[];
        },
        //跟多
        loadMore() {
            if (this.loadSign) {
                this.loadSign = false;
                if (this.formInline.pageNo > this.pageTotals) {
                    this.loadtxt = '没有数据了!';
                    return;
                }
                setTimeout(() => {
                    this.getSearch(this.formInline);
                }, 1000);
            }
		},
		handleChange(val){
			if(!val){
				return
			}
			// 大类变化时需将中类数据清理掉之后再次进行选择
			this.formInline.assetsTypeName = "";
			this.formInline.assetsSubTypeName = "";
			if( val ){
				let assetsKindList = JSON.parse(JSON.stringify(this.assetsKindList))
				//this.assetsTypeList = R.find(R.propEq('assetsKindName', val))(this.assetsKindList).assetsTypeNameList
				this.assetsTypeList = assetsKindList.find((ele)=>{
					if(ele.assetsKindName == val){
						return ele
					}
				})
			}else{
				this.assetsTypeList = [];
			}
			// R.find(R.propEq('assetsKindName', val))(this.assetsKindList)  --在this.assetsKindList列表数据中寻找"assetsKindName"为val的数据
			this.formInline.pageNo = 1;
			this.getSearch(this.formInline);
		},
		/* 资产中类名称 */
		handleTypeChange(val){
			if(!val){
				return
			}
			this.formInline.pageNo = 1;
			this.formInline.assetsTypeName = val;
			this.formInline.assetsSubTypeName = "";
			if( val ){
				let assetsTypeList = JSON.parse(JSON.stringify(this.assetsTypeList.assetsTypeList))
				this.assetsSubTypeList = assetsTypeList.find((ele)=>{
					if(ele.name == val){
						return ele
					}
				})
			}else{
				this.assetsSubTypeList = [];
			}
			this.getSearch(this.formInline);
		},
		/* 资产小类名称  */
		handleSubTypeChange(val){
			this.formInline.pageNo = 1;
			this.formInline.assetsSubTypeName = val;
			this.getSearch(this.formInline);
		},
		changeDevice(val){
            if(this.deviceNameTemp != val){
                this.formInline.deviceName = val;
                this.deviceNameTemp =val;
                this.formInline.pageNo = 1;
                this.getSearch(this.formInline);
            }
		}
    },
    watch: {
        //默认选择的人员
        supplierChecked (val) {
            let arr = [],that = this;
            val.forEach(res => {
                arr.push(res);
            });
            this.showPer = arr;
        },
        //打开框
        showDialog (val) {
            if (val) {
                this.resetData();            
                this.formInline.pageNo = 1;
                this.getSearch(this.formInline);
            }
            this.isShow = val;
            
        },
        // "formInline.deviceName"(val) {
        //     this.searchFunc(val);
        // },
        // //查询
        // "formInline.assetsKindName" (val) {
        //     this.searchFunc(val);
        // },
        // //查询
        // "formInline.assetsTypeName" (val) {
        //     this.searchFunc(val);
        // },
        //外部传入选中人员
        section:{
			handler: function(newValue, oldValue) {
                let that = this;
                that.supplierChecked=[];
                that.showPer = [];
                newValue.forEach(res => {
                    let isOk = false;
                    that.showPer.forEach(resp => {
                        if(resp.deviceCode == res.deviceCode){
                            isOk = true;
                        }
                    });
                    if(!isOk){
                        that.supplierChecked.push(res);
                    }
                });
			},
			immediate: true,
			deep: true
		},
    },
    computed: {
        //弹框宽度
        dialogWidth () {
            if (this.infinite) {
                return 1200 + 'px';
            } 
        },
        //多选就打开全选功能 单选就不打开
        isAllCheck () {
            if (this.infinite) {
                return false;
            } else {
                return true;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
    .oraWrap{
        border-top: 1px solid #e8e9ed;
        line-height: 100%;
        width: 100%;
        height: 100%;
        .el-cascader .el-input,
        .el-cascader .el-input__inner {
            &::-webkit-input-placeholder {
                color: #323232;
                font-size: 12px;
            }
        }
        .clear{
            clear: both;
        }
        .wrap-left{
            width: (885px/2);
            position: relative;
            .search-box{
                margin: 10px 20px 0 20px;
                position: relative;
                .el-form-item{
                    margin-bottom: 10px;
                }
                .row-bg{
                    margin-top:20px;
                }
                .search-show-box{
                    // margin-top: 20px;
                    background-color: white;
                    z-index: 100;
                    box-sizing: border-box;
                    width:100%;
                    .scroll-box{
                        font-size: 12px;
                        padding: 10px 10px;
                        box-sizing: border-box;
                        background-color: white;
                        color:#969696;
                        .check-box{
                            margin-right: 10px;
                        }
                        .pic-box{
                            margin-right: 10px;
                            .pic{
                                width: 30px;
                                height: 30px;
                                border-radius: 50%;
                                background-color: #409EFF;
                                font-size: 12px;
                                text-align: center;
                                line-height: 30px;
                                color: white;
                            }
                        }
                        .user-name{
                            max-width:200px;
                            font-size: 14px;
                            color: #323232;
                            overflow:hidden; /*内容超出宽度时隐藏超出部分的内容 */
                            text-overflow:ellipsis;/* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
                            white-space:nowrap; /*不换行 */
                        }
                        .department{
                            max-width:80px;
                            overflow:hidden; /*内容超出宽度时隐藏超出部分的内容 */
                            text-overflow:ellipsis;/* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
                            white-space:nowrap; /*不换行 */
                        }
                        .hospital{
                            max-width:70px;
                            overflow:hidden; /*内容超出宽度时隐藏超出部分的内容 */
                            text-overflow:ellipsis;/* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
                            white-space:nowrap; /*不换行 */
                        }
                        .row-two{
                            margin-top:7px;
                        }
                        .user-six{
                            margin:0 10px;
                        }
                        .on-line{
                            border-right:1px solid #969696;
                            margin:0 10px;
                        }
                        .name{
                            margin-bottom: 5px;
                        }
                        .job{
                            color: #aaaaaa;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            word-break: break-all;
                            width: 220px;
                        }
                    }
                }
                .load{
                    margin-top:115px;
                    font-size: 14px;
                    text-align: center;
                    padding: 10px 0;
                    .el-button{
                        margin-top: 20px;
                        border: 1px solid #409eff;
                        color: #409eff;
                        height:30px;
                    }
                }
            }
            .breadcrumb,.choose-all{
                display: inline-block;
                width: 100%;
                padding: 20px;
                box-sizing: border-box;
            }
            .choose-scroll{
                .scroll-box{
                    font-size: 14px;
                    margin: 0 20px 20px 20px;
                    box-sizing: border-box;
                    .next-box{
                        cursor: pointer;
                        box-sizing: border-box;
                        font-size: 0;
                        span{
                            color: #a0a1a4;
                            font-size: 14px;
                            vertical-align: middle;
                        }
                        i{
                            display: inline-block;
                            width: 14px;
                            height: 14px;
                            background: url(./choosePer/btn_next.svg) no-repeat center center;
                            background-size: 100% 100%;
                            vertical-align: middle;
                            margin-left: 10px;
                        }
                    }
                    .check-box{
                        margin-right: 10px;
                    }
                    .pic-box{
                        margin-right: 10px;
                        .pic{
                            width: 30px;
                            height: 30px;
                            border-radius: 50%;
                            background-color: #409EFF;
                            font-size: 12px;
                            text-align: center;
                            line-height: 30px;
                            color: white;
                        }
                    }
                    .name{
                        margin-bottom: 5px;
                    }
                    .job{
                        color: #aaaaaa;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        word-break: break-all;
                        width: 255px;
                    }
                    
                }
                .dept-box{
                    .dept-name{
                        margin-left: 24px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        word-break: break-all;
                        box-sizing: border-box;
                        padding-right: 10px;
                        position: relative;
                        &:after{
                            content: '';
                            display: block;
                            width: 1px;
                            height: 100%;
                            background-color: #ededed;
                            position: absolute;
                            right: 0;
                            top: 0;
                        }
                    }
                }
            }
        }
        .wrap-right{
            width: (885px/2);
            position: relative;
            &::after{
                content: '';
                display: block;
                width: 1px;
                height: 100%;
                background-color: #e8e9ed;
                position: absolute;
                top: 0;
                left: 0;
            }
            .choosed-box{
                .choosed-txt{
                    color: #ababab;
                    margin: 20px 20px 15px 20px;
                }
                .choosed-show{
                    margin: 0 20px 20px 20px;
                    .cshow-box{
                        // width: 48%;
                        background-color: #eff2f5;
                        border-radius: 5px;
                        box-sizing: border-box;
                        padding: 8px 12px;
                        margin-bottom: 10px;
                        margin-left: 10px;
                        font-size: 12px;
                        color: #969696;
                        float: left;
                        clear: both;
                        display: block;
                        .department{
                            max-width:80px;
                            overflow:hidden; /*内容超出宽度时隐藏超出部分的内容 */
                            text-overflow:ellipsis;/* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
                            white-space:nowrap; /*不换行 */
                        }
                        .hospital{
                            max-width:105px;
                            overflow:hidden; /*内容超出宽度时隐藏超出部分的内容 */
                            text-overflow:ellipsis;/* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
                            white-space:nowrap; /*不换行 */
                        }
                        .user-name{
                            max-width:200px;
                            font-size: 14px;
                            color: #323232;
                            overflow:hidden; /*内容超出宽度时隐藏超出部分的内容 */
                            text-overflow:ellipsis;/* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
                            white-space:nowrap; /*不换行 */
                        }
                        .row-two{
                            margin-top:7px;
                        }
                        .user-six{
                            margin:0 10px;
                        }
                        .on-line{
                            border-right:1px solid #969696;
                            margin:0 10px;
                        }
                        .bm-ver{
                            float: left;
                        }
                        .del{
                            margin-left: 20px;
                            float: right;
                        }
                        .cshow-box-l{
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            word-break: break-all;
                            .pername{
                                color: #424242;
                                margin-bottom: 6px;
                            }
                            .deptname{
                                color: #b5b6b8;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                word-break: break-all;
                            }
                        }
                        .del-btn{
                            cursor: pointer;
                        }
                    }
                }
                .choosed-btn-box{
                    text-align: right;
                    margin: 0 20px 10px;
                }
            }
        }
    }
</style>
<style  lang="scss">
    .oraWrap{
        .el-dialog__body{
            padding: 0;
        }
        .el-checkbox__label{
            display: none;
        }
        .el-breadcrumb,
        .el-breadcrumb__inner {
            cursor: pointer !important;
        }
    }
</style>